export type SdpViolationCode =
  | "sdes"
  | "unprotected-rtp"
  | "non-dtls-srtp"
  | "missing-dtls-srtp"
  | "missing-rtcp-mux"
  | "missing-bundle"
  | "missing-fingerprint";

export type SdpViolation = {
  code: SdpViolationCode;
  line?: string;
};

export type SdpPolicy = { ok: true } | { ok: false; violations: SdpViolation[] };

const DTLS_SRTP = new Set(["UDP/TLS/RTP/SAVP", "UDP/TLS/RTP/SAVPF"]);

const UNPROTECTED_RTP = new Set(["RTP/AVP", "RTP/AVPF", "UDP/RTP/AVP", "UDP/RTP/AVPF"]);

const NON_DTLS_SRTP = new Set(["RTP/SAVP", "RTP/SAVPF", "UDP/RTP/SAVP", "UDP/RTP/SAVPF"]);

export function evaluateSdpPolicy(sdp: string): SdpPolicy {
  const violations: SdpViolation[] = [];
  let dtls = false;
  let rtcpMux = false;
  let bundle = false;
  let fingerprint = false;

  for (const raw of sdp.split(/\r?\n/)) {
    const line = raw.trim();
    if (line.length === 0) continue;
    if (/^a=crypto:/i.test(line)) {
      violations.push({ code: "sdes", line });
      continue;
    }
    if (/^a=rtcp-mux$/i.test(line)) {
      rtcpMux = true;
      continue;
    }
    if (/^a=group:BUNDLE\b/i.test(line)) {
      bundle = true;
      continue;
    }
    if (/^a=fingerprint:/i.test(line)) {
      fingerprint = true;
      continue;
    }
    const media = /^m=\S+\s+\d+\s+(\S+)/i.exec(line);
    if (!media) continue;
    const proto = media[1].toUpperCase();
    if (DTLS_SRTP.has(proto)) {
      dtls = true;
      continue;
    }
    if (UNPROTECTED_RTP.has(proto)) {
      violations.push({ code: "unprotected-rtp", line });
      continue;
    }
    if (NON_DTLS_SRTP.has(proto)) {
      violations.push({ code: "non-dtls-srtp", line });
    }
  }

  if (!dtls) violations.push({ code: "missing-dtls-srtp" });
  if (!rtcpMux) violations.push({ code: "missing-rtcp-mux" });
  if (!bundle) violations.push({ code: "missing-bundle" });
  if (!fingerprint) violations.push({ code: "missing-fingerprint" });

  if (violations.length > 0) return { ok: false, violations };
  return { ok: true };
}
